import React from "react";
import { Link } from "react-router-dom";
import CopyRight from "../CopyRight";

const ActivationSuccess = () => {
  return (
    <div className="login full-height" style={{ textAlign: "center" }}>
      <h3>Your account has been activated successfully.</h3>
      <br />
      <div>
        Please{" "}
        <Link to="/login" style={{ fontWeight: "bold", color: "#0c0ca7" }}>
          {" "}
          click here
        </Link>{" "}
        to login.
      </div>{" "}
    </div>
  );
};

export default ActivationSuccess;



// WEBPACK FOOTER //
// ./src/components/Login/ActivationSuccess.js